function infiniteQueryOptions(options){return options}export{infiniteQueryOptions};